import * as React from "react";
import { SVGProps } from "react";
const SvgInfoLarge = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <g clipPath="url(#info-large_svg__a)">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M30.996 5.2c-.402-2.133-2.009-3.733-4.15-4.133C23.23.4 19.615 0 16 0 12.385 0 8.77.4 5.155 1.067c-2.142.4-3.75 2-4.15 4.133-1.34 7.2-1.34 14.533 0 21.6.4 2.133 2.008 3.733 4.15 4.133C8.77 31.6 12.385 32 16 32s7.23-.4 10.845-1.067c2.142-.4 3.75-2 4.15-4.133a58.58 58.58 0 0 0 0-21.6ZM16 14c.828 0 1.5.576 1.5 1.286v9.428c0 .71-.672 1.286-1.5 1.286s-1.5-.576-1.5-1.286v-9.428c0-.71.672-1.286 1.5-1.286Zm0-8a2 2 0 1 1 0 4 2 2 0 0 1 0-4Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="info-large_svg__a">
        <path fill="#fff" d="M0 0h32v32H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgInfoLarge;
